import Payment from "pages/Payment";

export default function PaymentPage() {
  return <Payment />;
}
